/** @jsxImportSource @emotion/react */
import React, {useState} from "react";
import {Icon, Menu, MenuItem} from "@blueprintjs/core";
import {Popover2} from "@blueprintjs/popover2";

const HamburgerMenu = (props) => {

    // Props
    const {items = [], onItemClick = () => {}, triggerAriaLabel = "Menú"} = props;

    // State
    const [isOpen, setIsOpen] = useState(false);

    if (items.length === 0) {
        return null;
    }

    const handleItemClick = (item) => {
        setIsOpen(false);
        onItemClick(item);
    };

    return (
        <Popover2
            isOpen={isOpen}
            onInteraction={setIsOpen}
            placement="bottom-end"
            content={(
                <Menu
                    css={{
                        minWidth: 220,
                        maxWidth: 360,
                        maxHeight: "calc(100vh - 160px)",
                        overflowY: "auto",
                        paddingTop: 5,
                        paddingBottom: 5
                    }}
                >
                    {items.map((item, index) => (
                        <MenuItem
                            key={item.to || index}
                            text={item.text}
                            active={item.isActive}
                            onClick={() => handleItemClick(item)}
                            css={{
                                lineHeight: 1.3,
                                whiteSpace: "normal"
                            }}
                        />
                    ))}
                </Menu>
            )}
        >
            <div
                css={{
                    cursor: "pointer",
                    color: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 44,
                    minWidth: 44,
                    transition: "all 0.4s",
                    "&:hover": {
                        opacity: 0.8
                    }
                }}
                aria-haspopup="menu"
                aria-expanded={isOpen}
                aria-label={triggerAriaLabel}
            >
                <Icon icon="menu" iconSize={24}/>
            </div>
        </Popover2>
    );
};

export default HamburgerMenu;
